import requestAnimationFrame
from 'vt-frontend-engine/app/scripts/principles/performance/requestAnimationFrame';
import _matchViewport from 'vt-frontend-engine/app/scripts/principles/responsive/match-viewport';
import { setupCollapse, updateElements } from './collapse';

(function() {
  const breakpoint = 'width-l';
  var widerThanBreakpoint = false;

  function checkWidth() {
    if (widerThanBreakpoint != _matchViewport(breakpoint)) {
      widerThanBreakpoint = !widerThanBreakpoint;
      updateElements('.js-reviews-collapsible-content',
                     '.js-reviews-collapsible-show-more',
                     '.js-reviews-collapsible-show-less',
                     widerThanBreakpoint);
    }
  }

  function _bindEvents() {
    $(window).on('resize', function () {
      requestAnimationFrame(checkWidth);
    });

    setupCollapse('.js-reviews-collapsible-content',
                  '.js-reviews-collapsible-show-more',
                  '.js-reviews-collapsible-show-less');
  }

  $(document).ready(function() {
    _bindEvents();
    checkWidth();
  });
})();
